/**
 * Custom JavaScript for Moshika Beauty theme.
 * Global Variant Management Engine & Theme Extensions.
 */

// ---------------------------------------------------------------------------
// 1. Global Universal Variant Engine
// ---------------------------------------------------------------------------
window.MoshikaVariantEngine = {
  /**
   * Universal Variant Matcher.
   * Matches selected options [opt1, opt2, opt3] against variants for 1, 2, or 3 option products.
   */
  findMatchingVariant: function (variants, selectedOptions) {
    if (!variants || !Array.isArray(variants)) return null;

    var validSelected = selectedOptions.map(function (val) {
      return (val !== undefined && val !== null) ? String(val).trim() : null;
    });

    return variants.find(function (variant) {
      var opt1 = variant.option1 != null ? String(variant.option1).trim() : null;
      var opt2 = variant.option2 != null ? String(variant.option2).trim() : null;
      var opt3 = variant.option3 != null ? String(variant.option3).trim() : null;

      var variantOpts = [opt1, opt2, opt3];

      for (var i = 0; i < validSelected.length; i++) {
        if (validSelected[i] !== null && validSelected[i] !== undefined) {
          if (variantOpts[i] !== validSelected[i]) {
            return false;
          }
        }
      }
      return true;
    }) || null;
  },

  /**
   * Calculates availability status of a candidate option value given current selections.
   * Returns: 'available', 'sold_out', or 'unavailable'
   */
  getOptionStatus: function (variants, currentSelected, optionPositionIndex, candidateValue) {
    if (!variants || !Array.isArray(variants)) return 'unavailable';

    var testSelected = currentSelected.slice();
    testSelected[optionPositionIndex] = String(candidateValue).trim();

    var match = this.findMatchingVariant(variants, testSelected);
    if (!match) return 'unavailable';
    return match.available ? 'available' : 'sold_out';
  },

  /**
   * Updates option pickers UI (Color Swatches, Size Swatches, Popover Values) with availability state.
   */
  updateOptionAvailabilityUI: function (container, productData, currentSelected) {
    if (!container || !productData || !productData.variants) return;

    var _self = this;
    var variants = productData.variants;

    // 1. Color Swatches
    var colorRadios = container.querySelectorAll('.ColorSwatch__Radio');
    colorRadios.forEach(function (radio) {
      var pos = parseInt(radio.getAttribute('data-option-position'), 10) - 1;
      if (isNaN(pos)) {
        var match = radio.name ? radio.name.match(/\d+/) : null;
        pos = match ? parseInt(match[0], 10) : 0;
      }
      var status = _self.getOptionStatus(variants, currentSelected, pos, radio.value);
      var label = container.querySelector('label[for="' + radio.id + '"]') || radio.nextElementSibling;

      if (label && label.classList.contains('ColorSwatch')) {
        label.classList.remove('is-unavailable', 'is-disabled', 'is-sold-out');
        radio.removeAttribute('disabled');

        if (status === 'unavailable') {
          label.classList.add('is-unavailable', 'is-disabled');
          radio.setAttribute('disabled', 'disabled');
        } else if (status === 'sold_out') {
          label.classList.add('is-sold-out');
        }
      }
    });

    // 2. Size Swatches
    var sizeRadios = container.querySelectorAll('.SizeSwatch__Radio');
    sizeRadios.forEach(function (radio) {
      var pos = parseInt(radio.getAttribute('data-option-position'), 10) - 1;
      if (isNaN(pos)) {
        var match = radio.name ? radio.name.match(/\d+/) : null;
        pos = match ? parseInt(match[0], 10) : 1;
      }
      var status = _self.getOptionStatus(variants, currentSelected, pos, radio.value);
      var label = container.querySelector('label[for="' + radio.id + '"]') || radio.nextElementSibling;

      if (label && label.classList.contains('SizeSwatch')) {
        label.classList.remove('is-unavailable', 'is-disabled', 'is-sold-out');
        radio.removeAttribute('disabled');

        if (status === 'unavailable') {
          label.classList.add('is-unavailable', 'is-disabled');
          radio.setAttribute('disabled', 'disabled');
        } else if (status === 'sold_out') {
          label.classList.add('is-sold-out');
        }
      }
    });

    // 3. Popover Values
    var popoverButtons = container.querySelectorAll('.Popover__Value');
    popoverButtons.forEach(function (btn) {
      var pos = parseInt(btn.getAttribute('data-option-position'), 10) - 1;
      if (isNaN(pos)) pos = 0;
      var val = btn.getAttribute('data-value');
      if (val) {
        var status = _self.getOptionStatus(variants, currentSelected, pos, val);
        btn.classList.remove('is-unavailable', 'is-disabled', 'is-sold-out');
        if (status === 'unavailable') {
          btn.classList.add('is-unavailable', 'is-disabled');
        } else if (status === 'sold_out') {
          btn.classList.add('is-sold-out');
        }
      }
    });
  }
};

// ---------------------------------------------------------------------------
// 2. DOM Ready Logic & Global Delegations
// ---------------------------------------------------------------------------
document.addEventListener("DOMContentLoaded", function () {
  /**
   * Formats minor unit monetary values (cents) using shop money format.
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || (window.theme && window.theme.moneyFormat) || '${{amount}}';

    function defaultTo(val, def) { return val == null || val !== val ? def : val; }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.'),
          dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }

    var value = '';
    var match = formatString.match(placeholderRegex);
    if (!match) return (cents / 100).toString();

    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
        break;
    }

    if (formatString.indexOf('with_comma_separator') !== -1) {
      return formatString.replace(placeholderRegex, value).replace(',00', '');
    } else {
      return formatString.replace(placeholderRegex, value).replace('.00', '');
    }
  }

  function updateSavings(container, variant) {
    var sectionEl = container || document;
    var priceListEl = sectionEl.querySelector ? sectionEl.querySelector(".ProductMeta__PriceList") : document.querySelector(".ProductMeta__PriceList");
    if (!priceListEl) return;

    var existingSavings = priceListEl.querySelector(".Price--savings");
    if (existingSavings) {
      existingSavings.remove();
    }

    if (!variant || !variant.compare_at_price || !variant.price) return;

    if (variant.compare_at_price > variant.price) {
      var savingsCents = variant.compare_at_price - variant.price;
      var formattedSavings = formatMoney(savingsCents, window.theme ? window.theme.moneyFormat : null);

      var priceEl = priceListEl.querySelector(".Price--highlight") || priceListEl.querySelector(".Price");
      if (priceEl) {
        var savingsEl = document.createElement("span");
        savingsEl.className = "Price--savings";
        savingsEl.innerText = formattedSavings + " Savings";
        priceListEl.insertBefore(savingsEl, priceEl);
      }
    }
  }

  // Re-calculate savings when user switches variant
  document.addEventListener("variant:changed", function (event) {
    if (event.detail && event.detail.variant) {
      updateSavings(event.target, event.detail.variant);
    }
  });

  // -----------------------------------------------------------------------
  // Global Event Delegation for Product Item Swatches (Grid / Cards)
  // Ensures dynamically added product cards (AJAX search, collections, etc.) work!
  // -----------------------------------------------------------------------
  document.addEventListener("change", function (event) {
    var radio = event.target.closest(".ProductItem .ColorSwatch__Radio");
    if (!radio) return;

    var productItem = radio.closest(".ProductItem");
    if (!productItem) return;

    var variantUrl = radio.getAttribute("data-variant-url");
    if (variantUrl) {
      var imgWrapper = productItem.querySelector(".ProductItem__ImageWrapper");
      var titleLink = productItem.querySelector(".ProductItem__Title > a");
      if (imgWrapper) imgWrapper.setAttribute("href", variantUrl);
      if (titleLink) titleLink.setAttribute("href", variantUrl);
    }

    // Update variant ID input if present on card
    var variantIdMatch = variantUrl ? variantUrl.match(/variant=(\d+)/) : null;
    if (variantIdMatch) {
      var cardIdInput = productItem.querySelector('input[name="id"]');
      if (cardIdInput) cardIdInput.value = variantIdMatch[1];
    }

    // Update card featured image
    var originalImageElement = productItem.querySelector(".ProductItem__Image:not(.ProductItem__Image--alternate)");
    if (radio.hasAttribute("data-image-url") && originalImageElement) {
      var targetImgId = radio.getAttribute("data-image-id");
      if (originalImageElement.getAttribute("data-image-id") !== targetImgId) {
        var newImageElement = document.createElement("img");
        newImageElement.className = "ProductItem__Image Image--fadeIn Image--lazyLoad";
        newImageElement.setAttribute("data-image-id", targetImgId);
        newImageElement.setAttribute("data-src", radio.getAttribute("data-image-url"));
        newImageElement.setAttribute("data-widths", radio.getAttribute("data-image-widths"));
        newImageElement.setAttribute("data-sizes", "auto");

        var aspectRatio = radio.getAttribute("data-image-aspect-ratio");
        if (aspectRatio && window.theme && window.theme.productImageSize === "natural") {
          originalImageElement.parentNode.style.paddingBottom = (100.0 / parseFloat(aspectRatio)) + "%";
        }
        if (aspectRatio) {
          originalImageElement.parentNode.style.setProperty("--aspect-ratio", aspectRatio);
        }
        originalImageElement.parentNode.replaceChild(newImageElement, originalImageElement);
      }
    }
  });

  // -----------------------------------------------------------------------
  // Fallback Quantity Selector Handler
  // -----------------------------------------------------------------------
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-action="decrease-quantity"], [data-action="increase-quantity"]');
    if (!btn) return;

    if (btn.hasAttribute('onclick')) return;

    var action = btn.getAttribute('data-action');
    var container = btn.closest('.QuantitySelector') || btn.parentElement;
    if (!container) return;

    var input = container.querySelector('.QuantitySelector__CurrentQuantity, input[name="quantity"], input[name="updates[]"]');
    if (!input) {
      input = (action === 'decrease-quantity') ? btn.nextElementSibling : btn.previousElementSibling;
    }
    if (!input || input.tagName !== 'INPUT') return;

    var minVal = parseInt(input.getAttribute('min'), 10);
    if (isNaN(minVal)) minVal = 1;

    var currentVal = parseInt(input.value, 10);
    if (isNaN(currentVal)) currentVal = 1;

    var newVal = (action === 'decrease-quantity')
      ? Math.max(currentVal - 1, minVal)
      : currentVal + 1;

    input.value = newVal;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }, false);

  // -----------------------------------------------------------------------
  // Global Event Delegation for Product Form Option Popovers (.ProductForm__Item)
  // Ensures option selector popovers open reliably on click.
  // -----------------------------------------------------------------------
  document.addEventListener("click", function (event) {
    var itemBtn = event.target.closest(".ProductForm__Item");
    if (!itemBtn) return;

    var popoverId = itemBtn.getAttribute("aria-controls");
    if (!popoverId) return;

    var popoverEl = document.getElementById(popoverId);
    if (!popoverEl) return;

    setTimeout(function () {
      var isHidden = popoverEl.getAttribute("aria-hidden") === "true";
      var isExpanded = itemBtn.getAttribute("aria-expanded") === "true";

      if (isHidden && !isExpanded) {
        popoverEl.setAttribute("aria-hidden", "false");
        itemBtn.setAttribute("aria-expanded", "true");
        document.documentElement.classList.add("no-scroll");

        var overlay = document.querySelector(".PageOverlay");
        if (overlay) {
          overlay.classList.add("is-visible");
          var closeHandler = function () {
            popoverEl.setAttribute("aria-hidden", "true");
            itemBtn.setAttribute("aria-expanded", "false");
            document.documentElement.classList.remove("no-scroll");
            overlay.classList.remove("is-visible");
            overlay.removeEventListener("click", closeHandler);
          };
          overlay.addEventListener("click", closeHandler);
        }
      }
    }, 10);
  }, false);

  // -----------------------------------------------------------------------
  // Global Event Delegation for Product Form Select Dropdowns
  // Handles native <select> option changes across product pages
  // -----------------------------------------------------------------------
  document.addEventListener("change", function (event) {
    var select = event.target.closest(".ProductForm__OptionSelect, .ProductForm__Option select");
    if (!select) return;

    var form = select.closest("form.ProductForm, .ProductForm") || select.closest(".shopify-section");
    if (!form) return;

    var productJsonEl = form.querySelector("[data-product-json]") || document.querySelector("[data-product-json]");
    if (!productJsonEl) return;

    try {
      var productData = JSON.parse(productJsonEl.innerHTML).product;
      var currentSelected = [];

      var optionEls = form.querySelectorAll(".ProductForm__Option");
      optionEls.forEach(function (optEl, idx) {
        var radio = optEl.querySelector('input[type="radio"]:checked');
        var sel = optEl.querySelector("select");
        if (radio) {
          currentSelected[idx] = radio.value;
        } else if (sel) {
          currentSelected[idx] = sel.value;
        } else {
          var valSpan = optEl.querySelector(".ProductForm__SelectedValue");
          currentSelected[idx] = valSpan ? valSpan.textContent.trim() : null;
        }
      });

      if (window.MoshikaVariantEngine) {
        var matchingVariant = window.MoshikaVariantEngine.findMatchingVariant(productData.variants, currentSelected);
        if (matchingVariant) {
          var idInputs = form.querySelectorAll('input[name="id"], select[name="id"]');
          idInputs.forEach(function (inp) {
            inp.value = matchingVariant.id;
          });

          var masterSelect = form.querySelector("#product-select-" + productData.id);
          if (masterSelect) {
            masterSelect.value = matchingVariant.id;
          }

          form.dispatchEvent(new CustomEvent("variant:changed", {
            bubbles: true,
            detail: { variant: matchingVariant, previousVariant: null }
          }));

          if (history.replaceState) {
            var newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + matchingVariant.id;
            window.history.replaceState({ path: newUrl }, "", newUrl);
          }
        }
      }
    } catch (err) {
      console.error("Error updating variant on select change:", err);
    }
  });
});

